import { useEffect, useState } from 'react';

/**
 * useNow(intervalMs = 30000) → a ticking Date.
 *
 * Re-renders the caller every `intervalMs` so "x minutes ago" / elapsed labels stay
 * fresh without each component owning its own setInterval. Pass 0/null to disable the
 * tick (returns the mount-time Date). Keep the interval coarse (≥ 15 s) in header chrome
 * — this is for minutes, not seconds.
 */
export function useNow(intervalMs = 30000) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (!intervalMs || intervalMs <= 0) return undefined;
    setNow(new Date());
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}

export default useNow;
